import { render, staticRenderFns } from "./BadgeIMF.vue?vue&type=template&id=b699cdf6"
import script from "./BadgeIMF.vue?vue&type=script&lang=js"
export * from "./BadgeIMF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports